export class ViewConfig {
    view_style: string;

    // data type - non field
    static DT_Header: string = "H";
    static DT_Separator: string = "S";
    // data type - field 
    static DT_Checkbox: string = "C";
    static DT_Date: string = "D";
    static DT_DateTime: string = "DT";
    static DT_Integer: string = "I";
    static DT_List: string = "L";
    static DT_MultiSelect: string = "MS";
    static DT_Number: string = "N";
    static DT_RadioList: string = "R";
    static DT_Text: string = "T";
    static DT_TextArea: string = "TA";
    static DT_Owner: string = "ONR";
    // data type - ui/complex field
    static DT_Url: string = "URL";
    static DT_Email: string = "EM";
    static DT_DropdownPanel: string = "DDP";
    static DT_File: string = "FL";
    static DT_ImageUrl: string = "IURL";
    static DT_ReadOnly: string = "RO";
    static DT_User: string = "UR";            // displays '<firstname> <lastname>'
    static DT_ImageButton: string = "IB";
    static DT_CustomInput: string = "CI";
    static DT_CellToggle: string = "CT";
    // button type
    static BT_Image: string = "IMG";
    static BT_FontAwesome: string = "";     // font-awesome icon is the default button type, thus value = ""
    // operations
    static OP_HAS: string = "HAS";
    static OP_NHAS: string = "NHAS";
    static OP_NEQ: string = "NEQ";
    static OP_EQ: string = "EQ";
    static OP_GTE: string = "GTE";
    static OP_GT: string = "GT";
    static OP_LTE: string = "LTE";
    static OP_LT: string = "LT";
}



// WEBPACK FOOTER //
// C:/Azure/Source/Workspaces/SalesNOW/SalesSOLO/WebSites/SalesSOLO.Web.Angular.telesales/src/app/models/view-config/view-config.model.ts